import { useState, useEffect } from 'react';
import { settingsAPI, STORAGE_URL } from '../services/api';

export const useSettings = () => {
    const [settings, setSettings] = useState(null);
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await settingsAPI.get();
                setSettings(response.data);
                if (response.data.logo) {
                    setLogo(`${STORAGE_URL}/${response.data.logo}`);
                }
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        };
        fetchSettings();
    }, []);

    return { settings, logo, setLogo };
};